export default [
  {
    prop: 'month',
    label: '月份',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'channel_name',
    label: '签约主体',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'total_price',
    label: '可开票金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'overinvoice_price',
    label: '已开票金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'ininvoice_price',
    label: '开票中金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'surplus_price',
    label: '剩余开票金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'action',
    width: '120px',
    label: '操作'
  }
]
